const NUMERICAL_REG = /^([1-9]\d*)$/;
const HOUR_REG = /^([1-9]\d*(h|hour|hours|\.))$/;
const MINUTE_REG = /^([1-9]\d*(m|mins|min))$/;
const HOUR_MINUTE_REG = /^([1-9]\d*h)([1-5]?\dm)|([1-9]\d*(hour|hours))([1-5]?\d(mins|min))$/;
const HOUR_ALL_REG = /^([0-9]\d*):([0-5][0-9])|([0-9]\d*).([0-9]|[0-9][0-9])$/;

export function budgetToMinutes(budget) {
  let result = 0;

  const budget_no_space = budget ? budget.replace(/\s+/g,"") : budget;

  if (NUMERICAL_REG.test(budget)) {
    result = Number(budget);
  }

  if (HOUR_REG.test(budget_no_space)) {
    let hours = 0;
    if (budget_no_space.endsWith('.')) {
      hours = Number(budget_no_space) * 60;
    } else {
      if (budget_no_space.endsWith('hour') || budget_no_space.endsWith('hours') || budget_no_space.endsWith('h')) {
        const hours_tmp = budget_no_space.split('h');
        hours = Number(hours_tmp[0]) * 60;
      } else {
        hours = budget_no_space;
      }
    }

    result = hours;
  }

  if (MINUTE_REG.test(budget_no_space)) {
    const mins = budget_no_space.split('m');
    result = Number(mins[0]);
  }

  if (HOUR_MINUTE_REG.test(budget_no_space)) {
    const time = budget_no_space.split('h');
    const hours_str = time[0];
    const hours_num = Number(hours_str) * 60;

    const mins_str = time[1].split('m');
    const mins_num = Number(mins_str[0]);
    if (Number.isNaN(mins_num)) {
      const split_str = mins_str[0].includes('ours') ? 'ours' : 'our';
      const mins_str_tmp = mins_str[0].split(split_str);
      const mins_num_tmp = Number(mins_str_tmp[1]);
      result = hours_num + mins_num_tmp;	
    } else {
      result = hours_num + mins_num;	
    }
  }

  if (HOUR_ALL_REG.test(budget_no_space)) {
    if (budget_no_space.includes(':')) {
      const time = budget_no_space.split(':');
      const hours_num = Number(time[0]) * 60;

      const mins_num = Number(time[1]);
      result = hours_num + mins_num;
    }

    if (budget_no_space.includes('.')) {
      const time = budget_no_space.split('.');
      
      const hours_num = Number(time[0]) * 60;
      const mins_num_tmp = time[1].length === 1 ? Number(time[1]) / 10 : Number(time[1]) / 100;
      const mins_num = mins_num_tmp * 60;
      result = hours_num + mins_num;
    }
  }

  return result;
}

export function minutesToBudget(value) {
  let result = '';

  if (value < 60 && value >= 0) {
    result = `${value}m`;
  }

  if (value >= 60) {
    const hours = Math.floor(value / 60);
    const minutes =  Math.ceil(value - (hours * 60));
    result = minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }

  return result;
}
